import { Images } from '@abcya/abcya_phaser';
import Phaser from 'phaser';

/**
 * This creates a sprite and defaults to an anchor of .5 and adds it to the game.
 */
export default class extends Phaser.GameObjects.Sprite {
  constructor (scene, x, y, asset, anchor = .5, parent = null, atlas = Images.DEFAULT_ATLAS) {
    super(scene, x, y, atlas, asset);

    // this.setOrigin(anchor);
  }
}
